import React, { useEffect, useState } from 'react';
import useCurrentUser from '../../hooks/useCurrentUser';
import Card from '../common/Card';
import { FilledButton } from '../common/Button';
import { AffiliatePartner } from '../../data_models/affiliatePartner';
import useRouting from '../../hooks/useRouting';
import { Chip } from '../common/Chip';
import IconButton from '../common/IconButton';
import { LuCopy } from "react-icons/lu";
import useDisplayNotifications from '../../hooks/useDisplayNotifications';
import { DisplayNotificationType } from '../../models/DisplayNotification';
import { FiExternalLink } from 'react-icons/fi';




interface PartnerListComponentPropsProps {
    affiliatePartner: Partial<AffiliatePartner>;
}

const PartnerListComponent: React.FC<PartnerListComponentPropsProps> = ({ affiliatePartner }) => {

    const { goToExternalLink } = useRouting();

    const { addNotification } = useDisplayNotifications();

    const copyCouponCode = (couponCode: string) => {
        navigator.clipboard.writeText(couponCode).then(() => {
            addNotification({
                message: 'Coupon code copied to clipboard',
                type: DisplayNotificationType.SUCCESS
            }, true);
        });
    };
    return (
        <div className={``}>
            <Card>
                <div className='flex flex-col md:grid md:grid-cols-4'>
                    <div className='col-span-3'>
                        <div className='flex flex-row items-center space-x-4'>
                            <div className="w-16 h-10 relative">
                                <img
                                    src={affiliatePartner.logoUrl}
                                    alt={`${affiliatePartner.name} logo`}
                                    className="h-full w-auto object-contain"
                                />
                            </div>
                            <p className='body2 font-bold'>{affiliatePartner.name}</p>
                        </div>

                        <div className='mt-3'>
                            <p className='body2 text-primary'>{affiliatePartner.customerBenefitDescription}</p>
                            <p className='body3 text-neutral-500'>{affiliatePartner.productDescription}</p>
                            <div className='mt-2 flex flex-row space-x-2'>{affiliatePartner.categories?.map((category) => (
                                <div key={category}>
                                    <Chip >
                                        {category}
                                    </Chip>
                                </div>
                            ))}</div>
                        </div>
                    </div>

                    {/* Action */}
                    <div className='mt-5 md:my-auto flex flex-col'>
                        {/* If coupon code */}
                        {(affiliatePartner.couponCode?.length || 0) > 0 ? (
                            <div>
                                <div className='flex flex-row items-center space-x-4'>
                                    <div className='flex flex-col'>
                                        <p className='caption2'>Coupon</p>
                                        <p className='body2 font-bold'>{affiliatePartner.couponCode}</p>
                                    </div>
                                    <IconButton
                                        icon={<LuCopy />}

                                        onClick={() => copyCouponCode(affiliatePartner.couponCode ?? '')}
                                    />
                                </div>
                                <FilledButton
                                    fullWidth
                                    onClick={() => goToExternalLink(affiliatePartner.partnerUrl ?? '')}
                                    icon={<FiExternalLink />}
                                >Claim Offer</FilledButton>
                            </div>
                        ) : // if affiliate link
                            (affiliatePartner.affiliateLink?.length || 0) > 0 ? (
                                <div>

                                    <FilledButton
                                        fullWidth
                                        onClick={() => goToExternalLink(affiliatePartner.affiliateLink ?? '')}
                                        icon={<FiExternalLink />}
                                    >Claim Offer</FilledButton>
                                </div>
                            ) : // if instruction
                                affiliatePartner.instruction ? (
                                    <div>
                                        <p>{affiliatePartner.instruction}</p>
                                        <FilledButton
                                            fullWidth
                                            onClick={() => goToExternalLink(affiliatePartner.partnerUrl ?? '')}
                                            icon={<FiExternalLink />}
                                        >Claim Offer</FilledButton>
                                    </div>
                                ) : null}

                    </div>

                </div>
            </Card >
        </div >
    );
};

export default PartnerListComponent;